import React from 'react';
import { Slider as AntSlider } from 'antd';

import './slider.less';

import classNames from 'classnames';

const defaultMarks = {
    0: '0',
    25: '25',
    50: '50',
    75: '75',
    100: '100'
};

/**
 * A styled slider
 *
 * {@link https://ant.design/components/slider}
 *
 * @module Slider
 * @param { Object } props - The component props
 * @param { string } [props.className] - the component className(s)
 * @param { Object } [props.marks] - custom marks for slider
 * @param { boolean } [props.showMarks] - whether or not marks are visible
 * @returns { React.ReactElement } A Slider component
**/
const Slider = ( props ) => {
    const {
        className,
        marks,
        showMarks = true
    } = props;

    const sliderClasses = classNames( {
        [ className ]: className ? true : false,
    } );

    return (
        <AntSlider 
            { ...props }
            className={ sliderClasses }
            marks={ showMarks ? marks ? marks : defaultMarks : null }
        />
    );
};
export { Slider };
